
const Branding = {
  logo: 'https://yarden-garden.s3.us-west-1.amazonaws.com/mobile/yarden_horizontal_lockup_bg-01.png',
  trademark: 'https://yarden-garden.s3.us-west-1.amazonaws.com/mobile/yarden_mark_bg-01.png'
}

export default Branding;
